module.exports = __webpack_public_path__ + "img/single.c1e11c63.jpg";